





































































































// 每个表单数据
import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import widgetFormItem from "./widgetFormItem.vue";
import util from "@/lib/util";
import draggable from "vuedraggable";

@Component({
  components: { draggable, widgetFormItem },
})
export default class extends AbpBase {
  // 接收拖拽时传递过来的数据
  @Prop() configFormData: any;
  @Prop() select: any;
  selectWidget: any = {};

  created() {
    this.selectWidget = this.select;
  }

  // 拖拽完成事件
  handleWidgetAdd(e) {
    // 获取当前拖拽的元素在放置栏中的下标
    const newIndex = e.newIndex;
    // 设置元素唯一key值
    const key = `${new Date().getTime()}_${Math.ceil(Math.random() * 99999)}`;
    // 拖拽完成后往当前元素的options添加remoteFunc，options平级添加key，model
    this.$set(this.configFormData.list, newIndex, {
      // 解构语法解构当前数据达到深拷贝效果，改变数据不会影响原有数据
      ...this.configFormData.list[newIndex],
      remoteFunc: "func_" + key,
      // 新增属性key
      key,
      // 新增属性model
      model: this.configFormData.list[newIndex].type + "_" + key,
      rules: [],
    });

    // 深拷贝数据，使重复组件之前相互不受影响
    this.$set(
      this.configFormData.list,
      newIndex,
      util.copy(this.configFormData.list[newIndex])
    );
    // 获取拖拽的表单数据,子父组件数据双向绑定实时改变右侧配置
    this.selectWidget = this.configFormData.list[newIndex];
  }

  // 点击栅格布局组件触发
  handleSelectWidget(index) {
    this.selectWidget = this.configFormData.list[index];
  }

  // 栅格布局删除组件方法
  removeWidgetElement(index) {
    if (this.configFormData.list.length - 1 === index) {
      if (index === 0) {
        this.selectWidget = {
          key: null,
          placeholder: null,
        };
      } else {
        this.selectWidget = this.configFormData.list[index - 1];
      }
    } else {
      this.selectWidget = this.configFormData.list[index + 1];
    }
    this.$nextTick(() => {
      this.configFormData.list.splice(index, 1);
    });
  }

  //栅格系统添加列
  handleColAdd(item: any) {
    item.columns.push({
      span: 12,
      list: [],
    });
  }

  // 栅格布局拖拽完成事件
  handleWidgetColAdd($event, row, colIndex) {
    const newIndex = $event.newIndex;
    const oldIndex = $event.oldIndex;
    const item = $event.item;
    // 设置元素唯一key值
    const key = `${new Date().getTime()}_${Math.ceil(Math.random() * 99999)}`;
    // 拖拽完成后往当前元素的options添加remoteFunc，options平级添加key，model
    this.$set(row.columns[colIndex].list, newIndex, {
      // 解构语法解构当前数据达到深拷贝效果，改变数据不会影响原有数据
      ...row.columns[colIndex].list[newIndex],
      ...row.columns[colIndex].list[newIndex],
      remoteFunc: "func_" + key,
      // 新增属性key
      key,
      parentKey: row.columns[colIndex].key,
      // 新增属性model
      model: row.columns[colIndex].list[newIndex].type + "_" + key,
      rules: [],
    });

    // 深拷贝数据，使重复组件之前相互不受影响
    this.$set(
      row.columns[colIndex].list,
      newIndex,
      util.copy(row.columns[colIndex].list[newIndex])
    );
    // 获取拖拽的表单数据,子父组件数据双向绑定实时改变右侧配置
    this.selectWidget = row.columns[colIndex].list[newIndex];
    row.columns[colIndex].config = this.configFormData.config;
    console.log((row.columns[colIndex].config = this.configFormData.config));
  }

  @Watch("select")
  handleSelectChange(itemdata) {
    this.selectWidget = itemdata;
  }

  @Watch("selectWidget")
  handleSelectWidgetChange(data) {
    this.$emit("update:select", data);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/formBuilder/widgetForm.vue